module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/home-slides/prod-05-9580f94c8af82aa71c9276c262e39749.jpg";